import { z } from "zod";
import { USER_ROLES, USER_STATUSES } from "../constants/index";
import { email, nonEmpty } from "./_primitives";

export const inviteUserSchema = z.object({
  email,
  name: nonEmpty,
  role: z.enum(USER_ROLES),
});

export const updateUserSchema = z.object({
  name: nonEmpty.optional(),
  role: z.enum(USER_ROLES).optional(),
  status: z.enum(USER_STATUSES).optional(),
});

export type InviteUserInput = z.infer<typeof inviteUserSchema>;
export type UpdateUserInput = z.infer<typeof updateUserSchema>;
